<script lang="ts">
    import { v4 as uuidv4 } from 'uuid';
    import { Button, Icon, Input, InputGroup } from "sveltestrap";
    import type { Third } from "../Model/Third";
    import { thirdsService } from "../services";
    import { Link, navigate } from "svelte-navigator";
    import AppWraper from "../components/AppWraper.svelte";

    export const editThird = null;

    let thirds: Third[];
    
    let offset = 0;
    let limit = 25;
    let searchFilter = null;
    let searchLawyers = false;

    // const dispatch = createEventDispatcher();

    load()

    async function load(){

        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: JSON.stringify({
                    searchFilter: searchFilter,
                    searchLawyers: searchLawyers
                })
            }
        }

        thirds = await thirdsService.findThirds(opts);

        thirds.sort((a,b) => {
            return a.name < b.name ? -1 : 1;
        })
        
    }

    function thirdUpdate(third: Third): void {
        let thirdAct = thirds.find(u => u.id == third.id)

        if (thirdAct) {
            thirdAct = third
            thirds = thirds;
        }
    }

    async function showmoreThirds(): Promise<void> {
        offset = offset + limit

        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: JSON.stringify({
                    searchFilter: searchFilter,
                    searchLawyers: searchLawyers
                })
            }
        }

        const thirdsMore = await thirdsService.findThirds(opts);

        thirdsMore.sort((a,b) => {
            return a.name < b.name ? -1 : 1;
        })

        thirdsMore.forEach(t => {
            thirds.push(t);
        });

        thirds = thirds;
    }

    function newThird(){
        navigate('/tercero/new');
	}

</script>

<style>

</style>

<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Listado de Terceros</h3>
                    </div>
                  </div>
              <div class="col-12 col-sm-3 mb-3">
                <div class="text-end">
                    <Button color="primary" on:click={() => newThird()}>
                        Nuevo Tercero
                    </Button>
                </div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                  <form on:submit|preventDefault={() => load()}>
                    <InputGroup>
                        <Input placeholder="Encuentra una persona" bind:value={searchFilter} />
                        <button type="submit" class="btn btn-primary"><Icon name="search" /></button>
                      </InputGroup>
                  </form>
              </div>
              <div class="col-12 col-sm-6 mb-3 d-flex align-items-center">
                <Button on:click={() => {searchLawyers ? searchLawyers = false : searchLawyers = true; load()}}>Ver abogados</Button>
                {#if searchLawyers}
                    <span class='small fst-italic ms-1'>(activado)</span>
                {/if}
            </div>
              <div class="col-12">
                {#if thirds?.length}
                <table class="table">
                    <thead>
                        
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Nombre</th>
                                <th scope="col">DNI</th>
                                <th scope='col'>Alias</th>
                            </tr>
                
                    </thead>
                    <tbody>
                        {#each thirds as third, index }
                            <tr>
                                <th scope="row">{index + 1}</th>
                                <td>
                                    <Link to="/tercero/{third.id}">
                                        {third.name} {third.surname1} {#if third.surname2}{third.surname2}{/if}
                                    </Link>
                                </td>
                                <td>{third.document}</td>
                                <td>{third.alias}</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
                <div class="col-12 text-center">
                    <button class="btn btn-primary btn-sm" type="button" on:click={() => showmoreThirds()} >Ver más</button>
                </div>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay Terceros para mostrar</h3>
                </div>
            {/if}
              </div>
            </div>
        </div>
    </div>
    
    <!-- <ThirdModal Third={editThird}  on:ThirdUpdate={() => ThirdUpdate(editThird)}/> -->

</AppWraper>




